import { RootGetterTypes } from './types';

export const getters = {
    [RootGetterTypes.GetDeleteFilterStatus](state) {
        return state.delete_filter_status
    },
}